import { useParams } from 'react-router-dom'

import type { ReportType } from '../Analytics.types'

export const useReportType = () => {
  const { reportType = 'profit' } = useParams<{ reportType: ReportType }>()

  return { reportType }
}
